<div class="checklist-container container margin-top-1rem">  
    <mat-accordion>
      <mat-expansion-panel *ngFor="let checklist of checklists">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ checklist.name }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        
        <div  *ngFor="let item of checklist.items">
          <div class="flex-row">
            <mat-checkbox [(ngModel)]="item.completed" (change)="toggleCompleted(item)">
              <span [class.completed]="item.completed">{{ item.item }}</span>
            </mat-checkbox>
            <!-- <button mat-icon-button (click)="editTask(item)">
              <mat-icon>edit</mat-icon>
            </button> -->
          </div>
          <p class="description" *ngIf="item.description">{{ item.description }}</p>
          <span class="due-date" *ngIf="item.dueDate !== '0000-00-00 00:00:00'">{{ item.dueDate | date }}</span>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>
  